import {createTheme} from "@mui/material/styles";
import MarkProRegularWoff2 from "../../../fonts/MarkPro/MarkW07-Regular.woff2";
import MarkProLightWoff2 from "../../../fonts/MarkPro/MarkW07-Light.woff2";
import MarkProBoldWoff2 from "../../../fonts/MarkPro/MarkW07-Bold.woff2";

const theme = createTheme({
    palette: {
        primary: {main: '#c00'},
        secondary: {
            main: '#f5f5f5',
            contrastText: '#645757',
        },
        background: {
            default: '#fff',
            paper: '#fff',
        },
    },
    typography: {
        fontFamily: 'MarkPro',
    },
    components: {
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    '&.Mui-focused': {
                        color: '#645757',
                    },
                },
            },
        },
        MuiPaginationItem: {
            styleOverrides: {
                rounded: {
                    borderRadius: '0',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    fontWeight: 'bold',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    boxShadow: 'none',
                    borderRadius: '0',
                    padding: '5px 15px',
                },
                contained: {
                    boxShadow: 'none',
                    border: `rgb(0, 0, 0, 0.25) 1px solid`,
                    padding: '5px 15px',
                },
                outlinedSecondary: {
                    boxShadow: 'none',
                    color: '#c00',
                    background: '#fff',
                    border: `rgb(0, 0, 0, 0.25) 1px solid`,
                    padding: '5px 15px',
                },
            },
        },
        MuiStepIcon: {
            styleOverrides: {
                root: {
                    '&.Mui-active': {
                        color: '#0f0f0f !important',
                    },
                    '&.Mui-completed': {
                        color: 'rgba(0, 0, 0, 0.38) !important',
                    },
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                    boxShadow: 'none',
                },
            },
        },
        MuiCssBaseline: {
            styleOverrides: `
                @font-face {
                    font-family: 'MarkPro';
                    font-style: normal;
                    font-display: swap;
                    font-weight: 440;
                    src: local('MarkPro/MarkW07-Regular.woff2'), local('MarkPro'), url(${MarkProRegularWoff2}) format('woff2');
                },
                @font-face {
                    font-family: 'MarkPro';
                    font-style: light;
                    font-display: swap;
                    font-weight: 340;
                    src: local('MarkPro/MarkW07-Light.woff2'), local('MarkPro'), url(${MarkProLightWoff2}) format('woff2');
                },
                @font-face {
                    font-family: 'MarkPro';
                    font-style: bold;
                    font-display: swap;
                    font-weight: 630;
                    src: local('MarkPro/MarkW07-Bold.woff2'), local('MarkPro'), url(${MarkProBoldWoff2}) format('woff2');
                },                
            `,
        },
    },
})

export default theme